import { Record as ImmutableRecord } from 'immutable'
import { RequestCatalogAction, RequestCatalogActions } from 'lib/actions/request_catalog'
import {
    AppWithGrantStatusValue,
    RequestCatalogSearchAction,
    RequestCatalogSearchActions,
    RequestCatalogUserAccessEntitlementPerAppValue,
} from 'lib/actions/request_catalog/request-catalog-search'
import { initialCreateReturn, initialDeleteReturn, initialEditReturn, initialListReturn } from 'lib/rpc'
import { initialActionReturn } from 'lib/rpcts'
import { App } from 'pbts/c1/api/app/v1/app'
import { AppEntitlement } from 'pbts/c1/api/app/v1/app_entitlement'
import { RequestCatalog, ResourceTypeWithEntitlementCount } from 'pbts/c1/api/requestcatalog/v1/requestcatalog'
import { RequestCatalogUserEntitlementPerAppValue } from 'redux_toolkit/browse-access'

export class RequestCatalogState extends ImmutableRecord({
    list: initialListReturn<RequestCatalog>(),
    item: initialActionReturn<RequestCatalog>(),
    create: initialCreateReturn<RequestCatalog>(),
    deleted: initialDeleteReturn(),

    appEntitlements: initialEditReturn(),
    accessEntitlements: initialEditReturn(),
    listApps: initialListReturn<App>(),
    listEntitlementsPerCatalog: initialListReturn<AppEntitlement>(),
    listEntitlementsForAccess: initialListReturn<AppEntitlement>(),

    apps: initialListReturn<AppWithGrantStatusValue>(),
    entitlementsPerApp: initialListReturn<RequestCatalogUserEntitlementPerAppValue>(),
    resourceTypesPerApp: initialListReturn<ResourceTypeWithEntitlementCount>(),
    shouldAlert: false,
    accessEntitlementsPerApp: initialListReturn<RequestCatalogUserAccessEntitlementPerAppValue>(),
}) {}

export const initialRequestCatalogState: RequestCatalogState = new RequestCatalogState()

export const requestCatalogReducer = (
    state: RequestCatalogState,
    action: RequestCatalogActions | RequestCatalogSearchActions,
): RequestCatalogState => {
    switch (action.type) {
        case RequestCatalogAction.editAppEntitlements:
            return state.set('appEntitlements', action.payload)
        case RequestCatalogAction.create:
            return state.set('item', action.payload)
        case RequestCatalogSearchAction.searchAppsWithGrantStatus:
            return state.set('apps', action.payload)
        case RequestCatalogSearchAction.searchEntitlementsPerApp:
            return state.set('entitlementsPerApp', action.payload)
        case RequestCatalogSearchAction.searchAccessEntitlementsPerApp:
            return state.set('accessEntitlementsPerApp', action.payload)
        case RequestCatalogSearchAction.searchResourceTypesPerApp:
            return state.set('resourceTypesPerApp', action.payload)
        default:
            return state
    }
}
